export enum QUERY_KEYS {
  DOCUMENT_THEMES_USER_DEFAULTS = 'DOCUMENT_THEMES_USER_DEFAULTS',
}

export default QUERY_KEYS
